/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InsuranceEndorsementsFileTableDirective {
    public restrict = 'E';
    public scope;
    public template;
    public value;
    public tab;
    constructor(private Process: IProcessService, private bsLoadingOverlayService: IBsLoadingService) {
        this.restrict = 'E';
        this.scope = {
            options: '=',
            deleteFunc: '&?',
        };
        // <tr ng-repeat="l in typeArray  | filter: {type:&quot;paid&quot;} | orderBy:[&quot;start_date&quot;]:true as index track by $index" ng-if="l.type === &quot;paid&quot; &amp;&amp; !l.deleted">
        this.template = `
        <div >
        <div class="panel">
            <div class="padding-style-1 white-background table-padding tab-table-border">

                <table class="table table-material md-custom-table" >
                    <thead>
                        <th class="first_col">Name</th>
                        <th>Download</th>
                        <th>Remove</th>
                    </thead>
                    <tbody>
                        <tr ng-repeat="l in typeArray | orderBy: l.file:true | limitTo:numLimit:start ">
                            <td class="d-none d-md-table-cell">{{ l.file }}</td>
                            <td class="d-none d-md-table-cell">
                                <md-button class='md-icon md-primary cus-md-icon-button m-0 w-unset' href="{{l.fileUrl}}" target='_blank' ng-show="l.fileUrl">
                                    <md-icon class='p-0' md-font-library='material-icons'>
                                        cloud_download 
                                    </md-icon>
                                </md-button>
                            </td>
                            <td class="d-none d-md-table-cell">
                                <md-button class='md-icon md-warn cus-md-icon-button m-0 w-unset' ng-click='deleteFile(l)'>
                                    <md-icon class='p-0' md-font-library='material-icons'>
                                        delete_forever                    
                                    </md-icon>
                                </md-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
                </div>
                <div class="content paging-container m-t-10">
                <ul class="pagination flex-center" ng-show="numLimit < typeArray.length">
                    <md-button class="md-raised-small d-inline-block" ng-hide="hidePrev()"  ng-click="PrevPage()">Previous</md-button>
                    <md-button class="md-raised-small d-inline-block pagination-button">{{currentPage}}</md-button>
                    <md-button class="md-raised-small d-inline-block" ng-hide="hideNext()" ng-click="nextPage()">Next</md-button>
                </ul>
                </div>
            </div>
        </div>
        `
    }

    public link($scope: any, $element: any, attrs: any): void {
        $scope.currentPage=1;
        $scope.numLimit=2;
        $scope.start = 0;
        $scope.countArray = [];
        $scope.queryType = attrs.tab;
        $scope.index = attrs.index;
        $scope.typeArray = [];
        $scope.$watch(() => {
            $scope.typeArray = $scope.options;
        });

        $scope.hideNext=function(){
            if(($scope.start+ $scope.numLimit) < $scope.typeArray.length){
              return false;
            }
            else 
            return true;
          };
        $scope.hidePrev=function(){
        if($scope.start===0){
            return true;
        }
        else 
        return false;
        };
        $scope.nextPage=function(){
            $scope.currentPage++;
            $scope.start=$scope.start+ $scope.numLimit;
        };
        $scope.PrevPage=function(){
            if($scope.currentPage>1){
                $scope.currentPage--;
              }
              $scope.start=$scope.start - $scope.numLimit;
        }

        $scope.deleteFile = function (file): any {
            $scope.deleteFunc({args: file});
        };
    }



    public static DirectiveFn(
        Process: IProcessService,
        bsLoadingOverlayService: IBsLoadingService
    ): InsuranceEndorsementsFileTableDirective {
        return new InsuranceEndorsementsFileTableDirective(Process, bsLoadingOverlayService);
    }
}

InsuranceEndorsementsFileTableDirective.DirectiveFn.$inject = ['Process', 'bsLoadingOverlayService'];

angular.module('beneple.global').directive('endorsementFileTable', InsuranceEndorsementsFileTableDirective.DirectiveFn);




// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/insurance_endorsement_file_table.directive.ts